module.exports = __webpack_public_path__ + "img/mall05.8697131c.png";